






















































import Vue from 'vue'
import Component from "vue-class-component";
import {Action} from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import {
  SelectWings, DatePickerWings,
  ToggleWings,
  SpoilerWings,
  TimeoutWings, InputWings
} from 'wings-ui-components';
import { notifyError, notifyConfirm } from '@/utils/notify-helper';
import {Ref } from "vue-property-decorator";
import {SystemActionsItem} from "@/store/user_management/system_actions/types";
import { ActionLog } from '@/store/auth/types';
import { getTranslatedParams } from '@/utils/notify-utils';

@Component({components: {
    SelectWings,
    DatePickerWings,
    ToggleWings,
    SpoilerWings,
    TimeoutWings,
    InputWings
  }})
export default class Originator extends Vue {
  @Ref('validator') validator:any;

  @Action("getSystemActionsItem") actionGetItem: any;
  @Action("saveSystemActions") actionSave: any;
  @Action("actionLog") actionLog: any;

  private localLang: string = 'ru';

  defaultItem(): SystemActionsItem {
    return {
      id: undefined,
      rus_name: "",
      eng_name: "",
      is_allowed: 0,
      action_source: undefined
    };
  }

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {}

  async created() {
    this.localLang = this.$i18n.locale;
    if (this.$route.params.id) {
      try {
        const data = await this.actionGetItem(this.$route.params.id)
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: 'success',
          object_type: "User action setting",
          object_name: data.rus_name + ' / ' + data.eng_name
        }
        await this.actionLog(this.logObject)
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
      } catch(err) {
        await this.actionLog({...this.logObject, action_status: 'failed'})
      }
    }
  }

  back():void{
    this.$router.push('/user_management/system_actions/');
  }

  onSaveItem():Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: "Editing",
            action_status: 'success',
            object_type: "User action setting",
            object_name: this.item.rus_name + ' / ' + this.item.eng_name,
            addititional_info: getTranslatedParams({action_source: this.item.action_source, is_allowed: this.item.is_allowed})
          }
          await this.actionSave(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject()
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
